import React, { useEffect } from 'react';
import '../campaign/campaignCreation/PropertiesGeneralSection.scss';
import './RewardSection.scss';
import ErrorFieldMessage from '../base/ErrorFieldMessage';
import CustomRadios from '../base/CustomRadios';

export function CustomTitleLabel(props) {
  return (
    <label
      className={`create-section-label create-section-label-bottom-space ${props.className}`}
    >
      {props.title}
    </label>
  );
}

export function CustomTitleWithRadio({
  title,
  options,
  tips,
  defaultValue,
  setValue,
}) {
  return (
    <div className="d-flex flex-column">
      {title ? <CustomTitleLabel title={title} /> : null}
      {tips ? <label className="tips-message">{tips}</label> : null}
      <div
        style={{
          display: 'flex',
        }}
      >
        <CustomRadios
          onChange={setValue}
          default={defaultValue}
          options={options}
        />
      </div>
    </div>
  );
}

export function CustomNumberInput(props) {
  const { title, setValue, defaultValue, errorId, error, errorMessage, customInputClassName } = props;

  // useEffect(() => {
  //   console.log('@@20: ', defaultValue);
  //   setValue(defaultValue);
  // }, [defaultValue]);
  return (
    <div className="d-flex flex-column">
      {title ? <CustomTitleLabel title={title} /> : null}
      <input
        type="number"
        onChange={({ target }) => setValue(target.value)}
        className={`${customInputClassName ? customInputClassName : 'custom-number-input-long'} ${error ? 'error-field' : ''}`}
        value={defaultValue}
        // defaultValue={defaultValue}
        onFocus={() => { }}
      />
      {errorId ? <ErrorFieldMessage id={errorId} error={error} message={errorMessage} /> : null}
    </div>
  );
}

export function CustomNumberInputWithUnit(props) {
  const {
    title,
    tips,
    setValue,
    defaultValue,
    unit,
    errorId,
    error,
    errorMessage,
    numberTitle,
    disabled,
  } = props;
  return (
    <div className="d-flex flex-column">
      {title ? <CustomTitleLabel title={title} /> : null}
      {tips ? <label className="tips-message">{tips}</label> : null}
      <div style={{ display: 'flex' }}>
        {numberTitle ? (
          <label className="help-message margin-right-10-percent">
            {numberTitle}
          </label>
        ) : null}
        <input
          type="number"
          onChange={({ target }) => setValue(target.value)}
          className={`custom-number-input-short ${error ? 'error-field' : ''}`}
          value={defaultValue}
          onFocus={() => { }}
          disabled={disabled}
        />
        <label className="help-message margin-left-10-percent">{unit}</label>
      </div>
      <ErrorFieldMessage id={errorId} error={error} message={errorMessage} />
    </div>
  );
}

export function CustomNumberMutipleInputWithUnit(props) {
  const {
    setFirstValue,
    setSecondValue,
    setFirstFocus,
    setSecondFocus,
    firstDefaultValue,
    secondDefaultValue,
    numberTitle,
  } = props;
  return (
    <div style={{ display: 'flex' }}>
      {numberTitle ? (
        <label className="help-message margin-right-10-percent">
          {numberTitle}
        </label>
      ) : null}
      <input
        type="number"
        onChange={({ target }) => setFirstValue(target.value)}
        className="custom-number-input-short"
        value={firstDefaultValue}
        onFocus={setFirstFocus}
      />
      <label className="help-message margin-left-10-percent margin-right-10-percent">
        {props.per}
      </label>
      <input
        type="number"
        onChange={({ target }) => setSecondValue(target.value)}
        className="custom-number-input-short"
        value={secondDefaultValue}
        onFocus={setSecondFocus}
      />
      <label className="help-message margin-left-10-percent">
        {props.unit}
      </label>
    </div>
  );
}

export function CustomNumberInputWithTips(props) {
  const {
    title,
    setValue,
    defaultValue,
    errorId,
    error,
    errorMessage,
    tips,
  } = props;

  return (
    <div className="d-flex flex-column">
      {title ? <CustomTitleLabel title={title} /> : null}
      {tips ? <label className="tips-message">{tips}</label> : null}
      <input
        type="number"
        onChange={({ target }) => setValue(target.value)}
        className="custom-number-input-long"
        value={defaultValue}
        // defaultValue={defaultValue}
        onFocus={() => { }}
      />
      <ErrorFieldMessage id={errorId} error={error} message={errorMessage} />
    </div>
  );
}
